module.exports = __webpack_public_path__ + "de77a722/img/mini-logo.18817ee5.svg";